export default __webpack_public_path__ + "static/media/alan-ai-bot.e69c710c.png";